import React, { useState } from "react";
import {
  Container,
  Card,
  CardContent,
  makeStyles,
  Grid,
  TextField,
  Button,
} from "@material-ui/core";
import QRCode from "qrcode";
import axios from "axios";
import QrCodeImage from "./QrCodeImage";
import CSVReader from "react-csv-reader";
import Navigation from "./Navigation";
import { CSVDownload } from "react-csv";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const RfidGenerate = () => {
  const [links, setLinks] = useState([]);
  const [downloadFlag, setDownloadFlag] = useState(false);

  // ── Active fields ──
  const [Firstname, setFirstname] = useState("");
  const [EmailAddress, setEmailAddress] = useState("");
  const [Ticket_Variant, setTicketVariant] = useState("");
  const [badgeType, setBadgeType] = useState("");
  const [RFID, setRFID] = useState("");         // maps to Reference_Number in RFID context
  const [qrCode, setQrCode] = useState("");

  // ── Commented out unused fields ──
  // const [Lastname, setLastname] = useState("");
  // const [Email, setEmail] = useState("");
  // const [mobile, setMobile] = useState("");
  // const [additionalGuests, setadditionalGuests] = useState("");
  // const [field2, setField2] = useState("");
  // const [category, setCategory] = useState("");
  // const [game1, setGame1] = useState("");
  // const [game2, setGame2] = useState("");
  // const [game3, setGame3] = useState("");
  // const [game4, setGame4] = useState("");
  // const [merch, setMerch] = useState("");
  // const [Reference_Number, setReference_Number] = useState("");

  const [exhibitorId] = useState(
    JSON.parse(localStorage.getItem("token")).token
  );
  const [imageUrl, setImageUrl] = useState("");
  const [uid, setUid] = useState("");

  // Sample CSV matches the 6 active fields
  const [sampleData] = useState([
    {
      Firstname: "Sample",
      EmailAddress: "someone@example.com",
      Ticket_Variant: "NYUC",
      badgeType: "Gold",
      RFID: "RFID123456",
      qrCode: "QR123456",

      // ── Commented out unused sample columns ──
      // Lastname: "Data",
      // mobile: "9876543210",
      // Reference_Number: "Delhi",
      // field2: "Extra field",
    },
  ]);

  const classes = useStyles();

  const handleSampleCsv = async () => {
    try {
      setTimeout(() => setDownloadFlag(false), 5000);
      setDownloadFlag(true);
    } catch (error) {
      console.log(error);
    }
  };

  const generateMultipleQrCode = async (csvData) => {
    try {
      if (csvData.length) {
        const multipleTicketsData = await saveMultipleRFIDTicket(csvData);
        const zip = new JSZip();
        for (let i = 0; i < multipleTicketsData.length; i++) {
          const qrData = multipleTicketsData[i];
          const qrID = qrData._id;
          const qrCodeImg = await QRCode.toDataURL(qrID);
          zip.file(
            `${qrData.EmailAddress || qrData.Email}.png`,
            qrCodeImg.split("base64,")[1],
            { base64: true }
          );
        }
        zip.generateAsync({ type: "blob" }).then((content) => {
          saveAs(content, "rfid-qr-codes.zip");
        });
      } else {
        alert("Invalid File data");
      }
    } catch (error) {
      alert("Something went wrong");
      console.log(error);
    }
  };

  const saveMultipleRFIDTicket = async (csvData) => {
    let savedDetails;
    await axios
      .post(process.env.REACT_APP_ADMIN + "/qrCode/generateMultipleRFID", { csvData })
      .then((resp) => {
        alert("RFID data added successfully");
        savedDetails = resp.data;
      })
      .catch((err) => {
        alert("Failed to save data");
        console.log(err);
      });
    return savedDetails;
  };

  const searchByRFID = async () => {
    await axios
      .get(process.env.REACT_APP_ADMIN + "/qrCode/getByRFID?Reference_Number=" + RFID)
      .then((data) => {
        if (!data.data) {
          alert("User not found");
          setRFID("");
          return;
        }
        setRFID(data.data.RFID || data.data.Reference_Number || "");
        setEmailAddress(data.data.EmailAddress || data.data.Email || "");
        setFirstname(data.data.Firstname || "");
        setTicketVariant(data.data.Ticket_Variant || "");
        setBadgeType(data.data.badgeType || "");
        setQrCode(data.data.qrCode || data.data.ticketId || "");
      })
      .catch((error) => console.log(error));
  };

  const saveOneTicket = async () => {
    let ticketDetails = {
      // ── Active fields ──
      Firstname,
      EmailAddress,
      Ticket_Variant,
      badgeType,
      RFID,
      qrCode,

      // ── Commented out unused fields ──
      // Lastname,
      // mobile,
      // Reference_Number,
      // additionalGuests,
      // field2,
      // category,
      // merch,
    };

    await axios
      .post(process.env.REACT_APP_ADMIN + "/qrCode/generateOneRfid", ticketDetails)
      .then((resp) => {
        const savedDetails = resp.data;
        toast(savedDetails?.mssg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        });
        setTimeout(() => {
          setRFID("");
          setEmailAddress("");
          setFirstname("");
          setTicketVariant("");
          setBadgeType("");
          setQrCode("");
        }, 1500);
      });
  };

  return (
    <Container className={classes.conatiner}>
      {/* Ambient background orbs */}
      <div className={classes.bgOrb1}></div>
      <div className={classes.bgOrb2}></div>
      <div className={classes.bgOrb3}></div>

      <Card className={classes.card}>
        <CardContent>
          <Navigation />
          <ToastContainer />

          <div className={classes.contentWrapper}>
            <Grid container spacing={4}>
              {/* ── Single RFID form ── */}
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div className={classes.formSection}>
                  <div className={classes.rfidBadge}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                      <rect x="2" y="5" width="20" height="14" rx="3" stroke="#e81b23" strokeWidth="1.8" />
                      <path d="M7 9h2M7 12h2M7 15h2" stroke="#e81b23" strokeWidth="1.8" strokeLinecap="round" />
                      <path d="M13 9c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2" stroke="rgba(232,27,35,0.6)" strokeWidth="1.5" strokeLinecap="round" />
                      <path d="M16 7.5c1.7 1 2.8 2.8 2.8 4.5s-1.1 3.5-2.8 4.5" stroke="rgba(232,27,35,0.35)" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                    <span>RFID Registration</span>
                  </div>

                  {/* ── Active fields ── */}
                  <TextField
                    className={classes.field}
                    autoFocus
                    value={RFID}
                    label="RFID"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setRFID(e.target.value)}
                    // onBlur={searchByRFID}
                    required
                  />
                  <TextField
                    className={classes.field}
                    value={Firstname}
                    label="First Name"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setFirstname(e.target.value)}
                  />
                  <TextField
                    className={classes.field}
                    value={EmailAddress}
                    label="Email"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setEmailAddress(e.target.value)}
                    required
                  />
                  <TextField
                    className={classes.field}
                    value={Ticket_Variant}
                    label="Ticket Variant"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setTicketVariant(e.target.value)}
                  />
                  <TextField
                    className={classes.field}
                    value={badgeType}
                    label="Badge Type"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setBadgeType(e.target.value)}
                  />
                  <TextField
                    className={classes.field}
                    value={qrCode}
                    label="QR Code"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setQrCode(e.target.value)}
                  />

                  {/* ── Commented out unused fields ──
                  <TextField className={classes.field} value={merch} disabled label="Merch. Collected" variant="outlined" fullWidth onChange={(e) => setMerch(e.target.value)} />
                  <TextField className={classes.field} label="Last Name" variant="outlined" fullWidth onChange={(e) => setLastname(e.target.value)} />
                  <TextField className={classes.field} label="Mobile" variant="outlined" fullWidth onChange={(e) => setMobile(e.target.value)} />
                  <TextField className={classes.field} label="Additional Guests" variant="outlined" fullWidth onChange={(e) => setadditionalGuests(e.target.value)} />
                  <TextField className={classes.field} label="Additional Field 2" variant="outlined" fullWidth onChange={(e) => setField2(e.target.value)} />
                  */}

                  <Button
                    className={classes.btn}
                    variant="contained"
                    onClick={saveOneTicket}
                  >
                    Save
                  </Button>

                  <div className={classes.qrCodesWrapper}>
                    {links.map((elem, index) => (
                      <QrCodeImage
                        key={index}
                        imageUrl={elem.qrCodeResponse}
                        keyid={elem.id}
                        Firstname={Firstname}
                      />
                    ))}
                  </div>
                </div>
              </Grid>

              {/* ── Bulk upload ── */}
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div className={classes.uploadSection}>
                  <h3 className={classes.sectionTitle}>Bulk RFID Upload</h3>
                  <p className={classes.sectionDescription}>
                    Upload a CSV file to register multiple RFID entries at once.
                    Required columns: <strong style={{ color: "#e81b23" }}>Firstname, EmailAddress, Ticket_Variant, badgeType, RFID, qrCode</strong>
                  </p>

                  <div className={classes.csvReaderWrapper}>
                    <div className={classes.uploadIcon}>
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                        <path d="M12 16V8M12 8L9 11M12 8L15 11" stroke="#e81b23" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M20 16.7C21.2 16 22 14.6 22 13C22 10.8 20.2 9 18 9C17.7 9 17.3 9.1 17 9.1C16.3 6.7 14.1 5 11.5 5C8.4 5 6 7.4 6 10.5C6 10.7 6 10.8 6 11C4.2 11.5 3 13.1 3 15C3 17.2 4.8 19 7 19H19C19.7 19 20.4 18.8 21 18.5" stroke="rgba(232,27,35,0.5)" strokeWidth="1.5" strokeLinecap="round" />
                      </svg>
                    </div>
                    <p className={classes.uploadHint}>Drop your CSV file here or click to browse</p>
                    <CSVReader
                      parserOptions={{ header: true }}
                      onFileLoaded={(data, fileInfo) => {
                        saveMultipleRFIDTicket(data);
                        console.log("data", data, "fileInfo", fileInfo);
                      }}
                    />
                  </div>

                  <Button
                    className={classes.btnOutline}
                    variant="outlined"
                    onClick={handleSampleCsv}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ marginRight: 8 }}>
                      <path d="M12 16L7 11M12 16L17 11M12 16V4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M3 20H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    Download Sample CSV
                  </Button>
                  {downloadFlag ? <CSVDownload data={sampleData} target="_blank" /> : null}
                </div>
              </Grid>
            </Grid>
          </div>
        </CardContent>
      </Card>
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "translateY(28px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes slideDown": {
    from: { opacity: 0, transform: "translateY(-20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes orbFloat1": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "33%": { transform: "translate(60px, -80px) scale(1.15)" },
    "66%": { transform: "translate(-40px, 40px) scale(0.9)" },
  },
  "@keyframes orbFloat2": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "33%": { transform: "translate(-70px, 50px) scale(1.1)" },
    "66%": { transform: "translate(50px, -60px) scale(0.95)" },
  },
  "@keyframes orbFloat3": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "50%": { transform: "translate(40px, 60px) scale(1.2)" },
  },
  "@keyframes uploadPulse": {
    "0%, 100%": { opacity: 0.6, transform: "scale(1)" },
    "50%": { opacity: 1, transform: "scale(1.08)" },
  },
  "@keyframes rfidPing": {
    "0%": { boxShadow: "0 0 0 0 rgba(232,27,35,0.4)" },
    "70%": { boxShadow: "0 0 0 10px rgba(232,27,35,0)" },
    "100%": { boxShadow: "0 0 0 0 rgba(232,27,35,0)" },
  },
  "@keyframes qrPopIn": {
    from: { opacity: 0, transform: "scale(0.85) translateY(16px)" },
    to: { opacity: 1, transform: "scale(1) translateY(0)" },
  },

  conatiner: {
    background: "linear-gradient(160deg, #0a0a0f 0%, #12121a 40%, #0d0d15 100%)",
    height: "100vh", width: "100vw", maxWidth: "100vw",
    position: "relative", padding: "0 !important", overflow: "hidden",
  },
  bgOrb1: {
    position: "fixed", top: "-15%", left: "-10%", width: 600, height: 600,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(232, 27, 35, 0.18) 0%, rgba(232, 27, 35, 0.04) 50%, transparent 70%)",
    animation: "$orbFloat1 12s ease-in-out infinite",
    pointerEvents: "none", zIndex: 0, filter: "blur(8px)",
  },
  bgOrb2: {
    position: "fixed", bottom: "-20%", right: "-10%", width: 700, height: 700,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(180, 10, 18, 0.14) 0%, rgba(120, 0, 10, 0.05) 50%, transparent 70%)",
    animation: "$orbFloat2 16s ease-in-out infinite",
    pointerEvents: "none", zIndex: 0, filter: "blur(12px)",
  },
  bgOrb3: {
    position: "fixed", top: "40%", left: "30%", width: 400, height: 400,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(255, 80, 80, 0.06) 0%, transparent 70%)",
    animation: "$orbFloat3 20s ease-in-out infinite",
    pointerEvents: "none", zIndex: 0, filter: "blur(20px)",
  },

  card: {
    background: "rgba(14, 14, 20, 0.88)",
    backdropFilter: "blur(30px)", WebkitBackdropFilter: "blur(30px)",
    border: "1px solid rgba(255, 255, 255, 0.06)",
    boxShadow: "0 8px 64px 0 rgba(0, 0, 0, 0.6), inset 0 1px 0 rgba(255,255,255,0.05)",
    height: "99.6%", margin: "0 !important", padding: "0 !important",
    overflowY: "scroll", position: "relative", zIndex: 1,
    animation: "$fadeIn 0.7s cubic-bezier(0.22, 1, 0.36, 1)",
    "&::-webkit-scrollbar": { width: "6px" },
    "&::-webkit-scrollbar-track": { background: "rgba(255, 255, 255, 0.03)", borderRadius: "10px" },
    "&::-webkit-scrollbar-thumb": { background: "linear-gradient(180deg, #e81b23 0%, #7b0008 100%)", borderRadius: "10px" },
  },

  contentWrapper: {
    padding: theme.spacing(4),
    animation: "$fadeIn 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
    [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
  },

  formSection: {
    background: "linear-gradient(160deg, #111118 0%, #0c0c14 100%)",
    padding: theme.spacing(4), borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    boxShadow: "0 4px 32px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.05)",
    transition: "box-shadow 0.4s ease, border-color 0.4s ease",
    animation: "$fadeIn 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
    "&:hover": {
      borderColor: "rgba(232, 27, 35, 0.3)",
      boxShadow: "0 8px 40px rgba(232, 27, 35, 0.15), inset 0 1px 0 rgba(255,255,255,0.07)",
    },
  },

  rfidBadge: {
    display: "inline-flex", alignItems: "center", gap: theme.spacing(1.2),
    background: "rgba(232, 27, 35, 0.1)", border: "1px solid rgba(232, 27, 35, 0.3)",
    borderRadius: "10px", padding: "8px 16px", marginBottom: theme.spacing(3),
    animation: "$rfidPing 2.5s ease-out infinite",
    "& span": {
      color: "#f0f0f5", fontSize: "1.2rem", fontWeight: 700,
      letterSpacing: "0.03em", textShadow: "0 0 20px rgba(232, 27, 35, 0.5)",
    },
  },

  uploadSection: {
    background: "linear-gradient(160deg, #111118 0%, #0c0c14 100%)",
    padding: theme.spacing(4), borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    boxShadow: "0 4px 32px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.05)",
    transition: "box-shadow 0.4s ease, border-color 0.4s ease",
    animation: "$fadeIn 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.1s backwards",
    "&:hover": {
      borderColor: "rgba(232, 27, 35, 0.3)",
      boxShadow: "0 8px 40px rgba(232, 27, 35, 0.15), inset 0 1px 0 rgba(255,255,255,0.07)",
    },
  },

  sectionTitle: {
    color: "#f0f0f5", fontSize: "1.4rem", fontWeight: 700,
    marginTop: 0, marginBottom: theme.spacing(3),
    letterSpacing: "0.03em", textShadow: "0 0 20px rgba(232, 27, 35, 0.4)",
  },

  sectionDescription: {
    color: "rgba(180, 180, 200, 0.55)", fontSize: "0.9rem",
    marginTop: 0, marginBottom: theme.spacing(3), lineHeight: 1.7,
  },

  field: {
    marginBottom: theme.spacing(2),
    "& .MuiOutlinedInput-root": {
      backgroundColor: "rgba(255, 255, 255, 0.07)", borderRadius: "10px",
      color: "#f0f0f5", transition: "all 0.3s ease",
      "& input": { color: "#f0f0f5" },
      "& fieldset": { borderColor: "rgba(255, 255, 255, 0.12)" },
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.10)",
        "& fieldset": { borderColor: "rgba(232, 27, 35, 0.5)" },
      },
      "&.Mui-focused": {
        backgroundColor: "rgba(232, 27, 35, 0.06)",
        boxShadow: "0 0 0 3px rgba(232, 27, 35, 0.12)",
        "& fieldset": { borderColor: "#e81b23", borderWidth: "2px" },
      },
      "&.Mui-disabled": {
        backgroundColor: "rgba(255,255,255,0.03)",
        "& input": { color: "rgba(180,180,200,0.3)", WebkitTextFillColor: "rgba(180,180,200,0.3)" },
        "& fieldset": { borderColor: "rgba(255,255,255,0.06)" },
      },
    },
    "& .MuiInputLabel-root": { color: "rgba(180, 180, 200, 0.6)" },
    "& .MuiInputLabel-root.Mui-focused": { color: "#e81b23", fontWeight: 600 },
    "& .MuiInputLabel-root.Mui-disabled": { color: "rgba(180,180,200,0.3)" },
  },

  btn: {
    marginTop: theme.spacing(1), marginBottom: theme.spacing(2),
    backgroundColor: "#e81b23", color: "#fff", fontWeight: 700,
    padding: "12px 36px", borderRadius: "10px", textTransform: "none",
    fontSize: "0.95rem", letterSpacing: "0.02em",
    boxShadow: "0 4px 16px rgba(232, 27, 35, 0.35)",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    position: "relative", overflow: "hidden",
    "&::after": {
      content: '""', position: "absolute", inset: 0,
      background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.15) 50%, transparent 100%)",
      backgroundSize: "200% 100%", backgroundPosition: "-200% center",
      transition: "background-position 0.4s ease",
    },
    "&:hover": {
      backgroundColor: "#c8121a", transform: "translateY(-3px) scale(1.02)",
      boxShadow: "0 8px 28px rgba(232, 27, 35, 0.55)",
      "&::after": { backgroundPosition: "200% center" },
    },
    "&:active": { transform: "translateY(-1px) scale(1.01)" },
  },

  btnOutline: {
    marginTop: theme.spacing(1), marginBottom: theme.spacing(2),
    backgroundColor: "transparent", color: "#e81b23", fontWeight: 700,
    padding: "11px 28px", borderRadius: "10px",
    border: "1.5px solid rgba(232, 27, 35, 0.5)", textTransform: "none",
    fontSize: "0.95rem", letterSpacing: "0.02em",
    display: "flex", alignItems: "center",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "&:hover": {
      backgroundColor: "rgba(232, 27, 35, 0.1)", borderColor: "#e81b23",
      transform: "translateY(-2px)", boxShadow: "0 6px 20px rgba(232, 27, 35, 0.25)",
    },
  },

  csvReaderWrapper: {
    marginTop: theme.spacing(1), marginBottom: theme.spacing(2),
    padding: theme.spacing(4, 3),
    background: "rgba(232, 27, 35, 0.04)", borderRadius: "14px",
    border: "2px dashed rgba(232, 27, 35, 0.3)", textAlign: "center",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "&:hover": {
      borderColor: "#e81b23", background: "rgba(232, 27, 35, 0.08)",
      boxShadow: "0 0 0 4px rgba(232,27,35,0.06)",
    },
    "& input[type='file']": { cursor: "pointer", color: "rgba(200,200,210,0.7)" },
    "& label": { color: "rgba(200,200,210,0.7)" },
  },

  uploadIcon: {
    display: "flex", justifyContent: "center",
    marginBottom: theme.spacing(1.5),
    animation: "$uploadPulse 3s ease-in-out infinite",
  },

  uploadHint: {
    color: "rgba(180,180,200,0.5)", fontSize: "0.82rem",
    margin: "0 0 12px 0", letterSpacing: "0.02em",
  },

  qrCodesWrapper: {
    marginTop: theme.spacing(3),
    display: "flex", flexDirection: "column", gap: theme.spacing(2),
    "& > *": { animation: "$qrPopIn 0.4s cubic-bezier(0.22, 1, 0.36, 1) backwards" },
  },

  title: {
    display: "flex", justifyContent: "center", alignItems: "center",
    background: "rgba(14,14,20,0.9)", color: "#fff",
    padding: 20, marginBottom: 10,
    boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
    animation: "$slideDown 0.5s cubic-bezier(0.22, 1, 0.36, 1)",
  },
}));

export default RfidGenerate;